import React, {useContext, useState} from 'react';
import {
  Dimensions,
  Modal,
  Platform,
  ScrollView,
  StyleSheet,
  View,
} from 'react-native';
import ActionsFactory from 'src/actions/ActionsFactory';
import AVText from 'src/components/elements/AVText';
import BackSubheader from 'src/components/elements/BackSubheader';
import RoundedButton, {ButtonType} from 'src/components/elements/RoundedButton';
import Styles from 'src/components/Styles';
import Localized from 'src/constants/AppStrings';
import AccountStore from 'src/stores/AccountStore';
import {getPreviousRouteName} from '../../../Util';
import {useNavigation} from '@react-navigation/native';
import FirebaseAnalytic from '../../../nativeModules/FirebaseAnalytic';
import Logger from 'src/logging/Logger';
import {getDescriber as getSnackDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';

import {getDescriber} from './descriptor/DescriptorType';
import Settings from 'src/Settings';
import AVTouchableOpacity from 'src/components/elements/AVTouchableOpacity';
import CancelIcon from 'src/components/img/svg/CancelIcon';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import MainConsumerContext from '../../MainConsumerContext';
import AppRoutes from '../../../AppRoutes';
const screenWidth = Dimensions.get('window').width;
const multipler = Platform.OS === 'web' ? 0.3 : 0.9;
const modalWidth = screenWidth * multipler;

const DeleteAccountScreen = () => {
  const navigation = useNavigation();
  const context = useContext(MainConsumerContext);
  const [showDeleteMdl, setShowDeleteMdl] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const previousRoute = getPreviousRouteName(navigation?.getState()?.routes);
  const {getDeleteAcntStyleDescriptor, deleteBtnColorrDescriptor} =
    getDescriber();
  const openDeleteMdl = () => {
    setShowDeleteMdl(true);
  };
  const handleContentLayout = (event) => {
    const {height} = event.nativeEvent.layout;

    setContentHeight(height);
  };
  const deletePressed = async () => {
    const {deleteAccount, logout, setIntentionalLogout} =
      ActionsFactory.getAccountActions();
    const deleteResponse = await deleteAccount(
      AccountStore.getAccountId(),
      AccountStore.getEmail(),
    );
    Logger.Log.LogAPIEvent(
      'AppAPI',
      'DeleteAccount',
      JSON.stringify({
        accountId: AccountStore.getAccountId(),
        email: AccountStore.getEmail(),
      }),
      JSON.stringify(deleteResponse),
    );
    FirebaseAnalytic.trackEvent('deletePressed', 'DeleteAccountScreen', {
      acocuntId: AccountStore.getAccountId(),
      email: AccountStore.getEmail(),
    });
    await logout();
    setIntentionalLogout(true);
    context?.actions.changeRootRoute(AppRoutes.Login);
    hideModal();
  };
  const renderModal = (): React.ReactNode => {
    return (
      <Modal visible={showDeleteMdl} onDismiss={hideModal} transparent={true}>
        <View style={styles.deleteAcntModalMain}>
          <View
            style={[
              styles.deleteAcntModalContainer,
              {minHeight: contentHeight + 180},
            ]}
          >
            <ScrollView contentContainerStyle={styles.scrollViewContent}>
              <AVTouchableOpacity
                aria-label={`X icon, Double tap to ${Localized.Buttons.cancel} offer details`}
                role="button"
                style={styles.closeModalTitleContainer}
                onPress={hideModal}
                accessible
                accessibilityLabel={Localized.Buttons.cancel}
                accessibilityRole="button"
                hitSlop={Styles.HitSlop_10}
                testID={'qa_ClosePopup_btn'}
              >
                <CancelIcon />
              </AVTouchableOpacity>
              <View
                style={styles.deleteAcntModalContentContainer}
                onLayout={handleContentLayout}
              >
                <AVText
                  aria-label={`${Localized.Success.delete_Acnt} label, text`}
                  accessibilityLabel={`${Localized.Success.delete_Acnt} label`}
                  testID={'qa_PopupTitle_txt'}
                  style={[
                    getDeleteAcntStyleDescriptor() &&
                      getDeleteAcntStyleDescriptor().deleteAcntTitle,
                    getSnackDescriber().snackDetailsBtnFontSTyle(),
                  ]}
                  accessible={true}
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
                >
                  {Localized.Success.delete_Acnt}
                </AVText>
                <AVText
                  accessible={true}
                  accessibilityLabel={`${Localized.Success.delete_acnt_desc} label`}
                  aria-label={`${Localized.Success.delete_acnt_desc} label, text`}
                  style={[
                    getDeleteAcntStyleDescriptor() &&
                      getDeleteAcntStyleDescriptor().deleteAcntDesc,
                    getSnackDescriber().snackDetailsBtnFontSTyle(),
                  ]}
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
                  testID={'qa_PopupMessage_txt'}
                >
                  {Localized.Success.delete_acnt_desc}
                </AVText>
              </View>

              <View>
                <RoundedAppButton
                  buttonType={RoundedAppButtonType.Outline}
                  onPress={deletePressed}
                  buttonViewStyle={styles.deleteConfirmBtnView}
                  buttonContainerStyle={styles.deleteConfirmBtnContainer}
                  accessibilityLabelValue={`${Localized.Buttons.okay}`}
                  titleText={Localized.Buttons.deletAcntBtn}
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
                  textStyle={
                    getDeleteAcntStyleDescriptor() &&
                    getDeleteAcntStyleDescriptor().btndelete
                  }
                  testID="qa_btn_DeleteYes"
                />
                <RoundedAppButton
                  buttonType={RoundedAppButtonType.Outline}
                  onPress={() => hideModal()}
                  buttonViewStyle={styles.hideBtnView}
                  buttonContainerStyle={styles.hideBtnContainer}
                  accessibilityLabelValue={`${Localized.Buttons.takemeBck}`}
                  titleText={Localized.Buttons.takemeBck}
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
                  textStyle={
                    getDeleteAcntStyleDescriptor() &&
                    getDeleteAcntStyleDescriptor().btndeleteTakeMe
                  }
                  testID="qa_btn_DeleteNo"
                />
              </View>
            </ScrollView>
          </View>
        </View>
      </Modal>
    );
  };
  const hideModal = () => {
    setShowDeleteMdl(false);
  };
  const isRedesign = getDescriber().getDeleteAcntDisclaimer(
    Settings.isRefiveAnd365Pay(),
  );
  return (
    <BackSubheader
      previousRoute={previousRoute}
      accessibilityLabel={'Back arrow'}
      accessibilityHint={`Press to navigate back to the ${previousRoute} screen`}
      title={Localized.Labels.delete_account}
      testId={'qa_DeleteAccount.PageTitle_txt'}
    >
      <ScrollView
        style={[styles.content, Settings.isRefiveAnd365Pay && styles.t1Padding]}
        contentContainerStyle={styles.scrollViewContent}
        keyboardShouldPersistTaps="handled"
      >
        <AVText
          style={[
            getDeleteAcntStyleDescriptor() &&
              getDeleteAcntStyleDescriptor().disclaimerTextBold,
            getSnackDescriber().snackDetailsBtnFontSTyle(),
          ]}
        >
          {Localized.Labels[isRedesign]}
        </AVText>
        <AVText
          style={[
            getDeleteAcntStyleDescriptor() &&
              getDeleteAcntStyleDescriptor().disclaimerText,
            getSnackDescriber().snackDetailsBtnFontSTyle(),
          ]}
        >
          {Localized.Labels.voluntary_deletion_2}
        </AVText>
      </ScrollView>
      <RoundedButton
        buttonType={ButtonType.action}
        color={deleteBtnColorrDescriptor()}
        onPress={openDeleteMdl}
        accessibilityLabel="Continue with Account Deletion"
        text={Localized.Buttons.delete}
        textStyle={
          getDeleteAcntStyleDescriptor() &&
          getDeleteAcntStyleDescriptor().deleteBtnTxt
        }
        wrapperStyle={
          getDeleteAcntStyleDescriptor() &&
          getDeleteAcntStyleDescriptor().deleteBtn
        }
        testID="qa_btn_Delete"
      />
      <>{showDeleteMdl && renderModal()}</>
    </BackSubheader>
  );
};

const styles = StyleSheet.create({
  content: {
    padding: Styles.Spacing.m3,
  },
  disclaimerText: {
    marginBottom: Styles.Spacing.m1,
    fontSize: Styles.Fonts.f1,
    color: Styles.primaryColor,
    fontFamily: Styles.FontFamily.figtreeRegular,
  },
  disclaimerTextBold: {
    marginBottom: Styles.Spacing.m2,
    fontWeight: 'bold',
    fontSize: Styles.Fonts.f1,
    fontFamily: Styles.FontFamily.figtreeRegular,
  },
  closeModalTitleContainer: {
    justifyContent: 'flex-end',
    position: 'absolute',
    top: Styles.Heights.h1,
    right: Styles.Spacing.m2,
  },
  deleteAcntModalMain: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  deleteAcntModalContainer: {
    width: modalWidth,
    backgroundColor: Styles.white,
    borderRadius: Styles.Spacing.m3,
    paddingHorizontal: Styles.Spacing.m3,
  },
  deleteAcntModalContentContainer: {
    marginTop: Styles.Heights.touchTargetHeight2 + 2,
    justifyContent: 'center',
    alignItems: 'center',
  },
  deleteAcntTitle: {
    fontSize: Styles.Fonts.f9,
    fontWeight: '700',
    color: Styles.Colors.PayNew.black01,
    fontFamily: Styles.FontFamily.aeonikRegular,
    textAlign: 'center',
  },
  deleteAcntDesc: {
    paddingTop: Styles.Spacing.m3,
    fontSize: Styles.Fonts.f1,
    fontWeight: '400',
    color: Styles.Colors.PayNew.black01,
    fontFamily: Styles.FontFamily.aeonikRegular,
    textAlign: 'center',
    paddingBottom: 25,
  },
  btndelete: {
    fontSize: Styles.Fonts.f1,
    fontWeight: '700',
    color: Styles.Colors.PayNew.white01,
    fontFamily: Styles.FontFamily.aeonikRegular,
    textAlign: 'center',
  },
  btndeleteTakeMe: {
    fontSize: Styles.Fonts.f1,
    fontWeight: '700',
    color: Styles.Colors.PayNew.error,
    fontFamily: Styles.FontFamily.aeonikRegular,
    textAlign: 'center',
    paddingHorizontal: Styles.Spacing.m2 + Styles.Spacing.m3,
  },
  deleteConfirmBtnView: {
    borderWidth: 2,
    borderRadius: Styles.Spacing.m4,
    backgroundColor: Styles.Colors.PayNew.error,
    borderColor: Styles.Colors.PayNew.error,
    height: undefined,
    width: '100%',
    paddingHorizontal: 0,
    paddingVertical: Styles.Spacing.m2,
  },
  deleteConfirmBtnContainer: {
    alignSelf: 'center',
    width: '100%',
  },
  t1Padding: {
    padding: Styles.Spacing.m2 + Styles.Spacing.m3,
  },
  hideBtnView: {
    borderWidth: 2,
    borderRadius: Styles.Spacing.m4,
    borderColor: Styles.Colors.PayNew.error,
    paddingHorizontal: Styles.Spacing.m0,
    paddingVertical: Styles.Spacing.m2,
    width: '100%',
    height: undefined,
  },
  hideBtnContainer: {
    alignSelf: 'center',
    marginTop: Styles.Spacing.m2 + Styles.Spacing.m1,
    width: '100%',
  },
  scrollViewContent: {
    flexGrow: 1,
    paddingBottom: Styles.Spacing.m5 + Styles.Spacing.m4,
  },
});

export default DeleteAccountScreen;
